module.exports = __webpack_public_path__ + "img/megaphone.aa5eb705.svg";